import { apiGet } from "utils/apiClient";

export type InstrumentEventType = "maturity" | "amortization" | "coupon" | "payment";
export type InstrumentEventSource = "bonistas" | "manual_catalog";

export interface InstrumentEvent {
  id: string;
  ticker: string;
  normalizedTicker: string;
  symbols: string[];
  date: string;
  family?: string;
  currency: string;
  saldo?: number | null;
  coupon?: number | null;
  amortization?: number | null;
  total?: number | null;
  eventType: InstrumentEventType;
  source: InstrumentEventSource;
  sourceUrl: string;
  confidence: "estimated" | "official";
}

export interface InstrumentEventsResponse {
  source: InstrumentEventSource;
  sourceUrl: string;
  confidence: "estimated" | "official";
  events: InstrumentEvent[];
  updatedAt: string;
}

export async function fetchInstrumentEvents(): Promise<InstrumentEventsResponse> {
  return apiGet<InstrumentEventsResponse>("/market/instrument-events");
}

